(function($) {
    var numSlick = 0;

    // Targets each instance of the image slider
    $('.slider-block').each( function() {
        numSlick++;

        // Initiate testimonial sliders
        $(this).addClass( 'slider-block' + numSlick ).slick({
            accessibility: false,
            adaptiveHeight: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev is-inactive">Previous</button>"',
            nextArrow: '<button type="button" class="slick-next is-inactive">Next</button>"',
            dots: false,
            fade: true,
            infinite: false,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 800,
            responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    dots: true,
                }
            },
            ]
        });

    });

}(jQuery));

slickPaginationPosition = function() {

    // Fade arrows in
    setTimeout(function() {
        $('.slider-block .slick-arrow').removeClass('is-inactive');
    }, 300);

    // Update arrow color based on slide background
    $('.slider-block').each(function() {
        var currentSlideBackground    = $(this).find('.slick-current .feature-block').data('bg');
        var currentSlideImageHeight   = $(this).find('.slick-current .figure').outerHeight();
        var currentSlideDotsPosition  = currentSlideImageHeight + 30;
        var currentSlideArrowPosition = currentSlideImageHeight - 30;

        $(this).addClass(currentSlideBackground);

        // Dynamically position dots/arrows based on current slide
        if ($(window).width() < 991) {
            $(this)
                .find('.slick-dots')
                .css('top', currentSlideDotsPosition);

            $(this)
                .find('.slick-arrow')
                .css('top', currentSlideArrowPosition);
        }
    });
};

$(window).on('load resize', function() {
    slickPaginationPosition();

    // Relocate dots based on slide offset
    $('.slider-block').on('afterChange', function(event, slick, currentSlide, nextSlide){
        slickPaginationPosition();
    });

});
